export default __webpack_public_path__ + "static/media/logo.29b00172.jpg";